module.exports = __webpack_public_path__ + "2392a1368b9f7be9eba0cc0940cca44b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/university_notre_dame_2023_chart.png
// module id = 1747
// module chunks = 0